import {baseApi} from "./apiService";

export interface CustomerLoginPayload {
    email: string;
    password: string;
}

export interface CustomerRegisterPayload {
    firstName: string;
    lastName?: string;
    email: string;
    phone?: string;
    password: string;
}

export interface CustomerTokenResponse {
    token: string;
    refresh_token: string;
}

export const customerAuthApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
        // Uses Lexik JWT json_login endpoint
        customerLogin: builder.mutation<CustomerTokenResponse, CustomerLoginPayload>({
            query: (credentials) => ({
                url: 'customer/login_check',
                method: 'POST',
                body: credentials,
            }),
        }),
        customerRegister: builder.mutation<CustomerTokenResponse, CustomerRegisterPayload>({
            query: (data) => ({
                url: 'customer/register',
                method: 'POST',
                body: data,
            }),
        }),
        // Uses Lexik JWT refresh endpoint
        customerRefreshToken: builder.mutation<CustomerTokenResponse, { refresh_token: string }>({
            query: (data) => ({
                url: 'customer/token/refresh',
                method: 'POST',
                body: data,
            }),
        }),
    }),
})

export const {
    useCustomerLoginMutation,
    useCustomerRegisterMutation,
    useCustomerRefreshTokenMutation,
} = customerAuthApi
